// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"or-z","breadcrumbForward":"pr-z","breadcrumbBack":"qr-z","selected":"rr-z"};